import React from 'react';

const BadgePreview = ({ text, textColor, backgroundColor }) => {
    return (
        <div style={{
            display: 'inline-block',
            padding: '4px 12px',
            borderRadius: 4,
            backgroundColor: backgroundColor,
            color: textColor,
            fontSize: '12px',
            fontWeight: 600,
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}>
            {text}
        </div>
    );
};

export default BadgePreview;
